<div>
  <span placement="right" pTooltip="{{entityTypeKey | translate}}" tooltipPosition="right" showDelay="250">{{entityType}}</span>
  <button type="button" class="icon-wrapper" tabindex="0" (click)="openMswfRules($event);" *ngIf="params?.data?.multiStepWorkflow" [attr.aria-label]="'multistep.workflow.button' | translate" pTooltip="{{'multistep.workflow.button' | translate}}" showDelay="250"><i class="icon-workflow"></i></button>
</div>
